import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid'; // Importez le générateur v4

@Injectable({
  providedIn: 'root'
})
export class SecurityService {
  constructor() {}

  generateSecureGuid(): string {
    return uuidv4();
  }

  /**
   * Génère un mot de passe aléatoire sécurisé d'au moins 20 caractères,
   * contenant des majuscules, des minuscules et des chiffres (sans symboles).
   */
  generateRandomPassword(): string {
    // Définition des ensembles de caractères à utiliser
    const sets = {
      uppercase: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
      lowercase: 'abcdefghijklmnopqrstuvwxyz',
      numbers: '0123456789'
      // Les symboles sont exclus selon la demande
    };

    // La longueur cible minimale est de 25 caractères
    const targetLength = 25;
    let password = '';
    // Combinaison de tous les caractères autorisés
    let allCharacters = sets.uppercase + sets.lowercase + sets.numbers;

    // 1. Assurer la présence d'au moins un caractère de chaque type requis (3 types)
    password += this.getRandomChar(sets.uppercase); // 1 majuscule
    password += this.getRandomChar(sets.lowercase); // 1 minuscule
    password += this.getRandomChar(sets.numbers); // 1 chiffre

    // 2. Remplir le reste de la longueur cible (targetLength - 3)
    for (let i = 3; i < targetLength; i++) {
      password += this.getRandomChar(allCharacters);
    }

    // 3. Mélanger le mot de passe pour que les premiers caractères ne soient pas toujours
    // dans le même ordre (majuscule, minuscule, chiffre...)
    password = this.shuffleString(password);

    return password;
  }

  /**
   * Obtient un caractère aléatoire d'un ensemble donné, en utilisant
   * l'API cryptographique sécurisée.
   */
  private getRandomChar(charSet: string): string {
    const randomBuffer = new Uint32Array(1);
    // Utilise l'API cryptographique pour une meilleure entropie
    window.crypto.getRandomValues(randomBuffer);
    const randomIndex = randomBuffer[0] % charSet.length;
    return charSet.charAt(randomIndex);
  }

  /**
   * Mélange une chaîne de caractères de manière sécurisée (algorithme de Fisher-Yates),
   * en utilisant l'API cryptographique pour la sélection des indices.
   */
  private shuffleString(s: string): string {
    const a = s.split('');
    // Utiliser une boucle `for` inversée pour l'algorithme Fisher-Yates
    for (let i = a.length - 1; i > 0; i--) {
      // Calculer un index aléatoire sécurisé entre 0 et i (inclus)
      const randomBuffer = new Uint32Array(1);
      window.crypto.getRandomValues(randomBuffer);
      // Utiliser l'opération modulo pour obtenir un index dans la plage [0, i]
      const j = randomBuffer[0] % (i + 1);

      // Échanger les éléments
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a.join('');
  }
}
